import "dayjs/locale/en-gb";
import "dayjs/locale/cs";
import "./global.scss";
import "./sentry";

import { createElement } from "react";
import { createRoot } from "react-dom/client";
import { initReactI18next } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { Amplify, Auth } from "aws-amplify";
import { H } from "highlight.run";
import i18n from "i18next";
import i18NLanguageDetector from "i18next-browser-languagedetector";

import commonCS from "./assets/locales/cs/common.json";
import commonEN from "./assets/locales/en/common.json";
import { config } from "./config";
import { Pages } from "./pages";
import { handleError } from "./utils/error";

Amplify.configure({
    Auth: {
        region: config.region,
        userPoolId: config.auth.userPoolId,
        userPoolWebClientId: config.auth.clientId,
    },
    API: {
        endpoints: [
            {
                name: "RestAPI",
                endpoint: config.restApi.baseUrl,
            },
        ],
        graphql_headers: async () => {
            try {
                const session = await Auth.currentSession();

                return {
                    Authorization: session?.getIdToken()?.getJwtToken?.(),
                };
            } catch (err) {
                handleError(err, { silent: true });
            }
        },
    },
    aws_appsync_graphqlEndpoint: config.api.endpointUrl,
    aws_appsync_region: config.region,
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    aws_appsync_apiKey: config.api.key,
});

i18n.use(i18NLanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { common: commonEN },
            cs: { common: commonCS },
        },
        fallbackLng: "cs",
        interpolation: {
            escapeValue: false,
        },
    });

if (config.highlightIoProjectID) {
    H.init(config.highlightIoProjectID, {
        serviceName: "tt-stag-client",
        tracingOrigins: true,
        networkRecording: {
            enabled: true,
            recordHeadersAndBody: true,
            urlBlocklist: [],
        },
    });
}

createRoot(document.getElementById("root") as HTMLDivElement).render(
    createElement(BrowserRouter, {}, createElement(Pages, {}))
);
